import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";

export default {
  icon: AssignmentTurnedInOutlinedIcon,
};
